<template>
  <nav id='sidebar'
       class='sidebar'>

    <div id='title'
         class='base-five border-bottom'>

      <router-link :to="{name: 'home', params: {language: language}}">
        <svg xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink"
             width="172"
             height="23.1"
             viewBox="0 0 172 23.1">
          <defs>
            <path id="a"
                  d="M.5.2h171.1v22.6H.5z" />
          </defs>
          <clipPath id="b">
            <use xlink:href="#a"
                 overflow="visible" />
          </clipPath>
          <path clip-path="url(#b)"
                d="M159.7 14.7c0-2.3.5-4.9 3-4.9 2.3 0 3 2.2 3 4.9 0 2.2-.5 4.9-3 4.9-.5 0-1.6-.1-2.2-1.2-.7-1.2-.8-2.7-.8-3.7m-6 0c0 1.9.4 4.2 2.2 5.9 1.5 1.4 3.7 2.3 7.1 2.3 3.2 0 5.1-1 6.4-2.2 1.6-1.6 2.2-3.9 2.2-6.1 0-5.5-3.9-8-8.9-8-6.1-.1-9 3.3-9 8.1m-8.3 7.8h5.8V7h-5.8v15.5zm0-18.1h5.9V.3h-5.9v4.1zm-11.9 15c-2.6 0-2.9-3.2-2.9-4.6 0-1.4.3-4.7 2.9-4.7 2 0 2.9 2 2.9 4.6.1 2.6-.8 4.7-2.9 4.7M136.4.2v8.6c-1-1.1-2.1-2.2-4.7-2.2-1.9 0-3.7.6-5.1 2.1-1 1.1-1.9 2.7-1.9 6 0 3.8 1.5 8.1 6.8 8.1 3.4 0 4.6-1.8 5.2-2.6l.1 2.3h5.5c-.1-1.3-.2-2.6-.2-3.8V.2h-5.7zM105.9 7v8.7c0 3 .3 7 5.7 7 1.4 0 3.3-.2 4.9-2.7l.1 2.4h5.7c0-1.2 0-1.4-.1-2.7V7h-5.8v9c0 .9 0 3.1-2.4 3.1-2.3 0-2.3-2.2-2.3-3V7h-5.8zm-5.7.1V2.5l-5.6 2.2v2.4h-3v3.7h2.9v7.4c0 3 .9 4.5 5.5 4.5 2 0 3-.2 3.8-.3v-3.6c-.7.1-1 .1-1.4.1-2.2 0-2.2-.9-2.2-2.8v-5.4h3.7V7.1h-3.7zM75.6 17.4c-.1 5 4.5 5.4 7.6 5.4 1.4 0 7.4 0 7.4-5.2 0-3-2.2-3.8-3.6-4.2l-4.1-1.1c-.9-.2-1.6-.6-1.6-1.5 0-1 .8-1.4 1.7-1.4.9 0 1.4.3 1.6.8.2.5.2 1 .2 1.5h5.5c-.2-4.3-3.7-5.2-7-5.2-2.3 0-4.1.4-5.5 1.3-1 .7-1.8 2-1.8 3.5 0 3.2 2.8 3.9 3.8 4.2l3.1.9c1.3.3 2.2.6 2.2 1.7 0 .7-.4 1.6-1.8 1.6-1 0-1.5-.5-1.7-1-.2-.5-.2-1.1-.2-1.4h-5.8zM64 3.3l4.1 10.9h-8.4L64 3.3zM53.2 22.5h3.2l2.4-5.8h10.3l2.4 5.8h3.4L65.9.3h-3.3l-9.4 22.2zm-4.8 0V2.9h7.4V.2H37.9v2.6h7.4v19.6h3.1zM29.6 3.3l4.1 10.9h-8.4l4.3-10.9zM18.8 22.5H22l2.4-5.8h10.3l2.4 5.8h3.4L31.5.3h-3.3l-9.4 22.2zM3.6 2.8h3.7c2.7 0 4.5.4 5.9 1.9 2.1 2.3 2.2 6.1 2.2 6.9 0 1.3-.1 4.9-2.9 7-1.5 1.1-3.7 1.2-5.8 1.2h-3v-17zM.5 22.5h6.2c3.3 0 6 0 8.2-1.8 1.7-1.4 3.7-4.3 3.7-9.1 0-3-.8-6.1-2.7-8.4C13.4.3 9.9.3 6.9.3H.5v22.2z" />
        </svg>
      </router-link>

      <div v-if='screenSize.mobile === true'
           class='three-bar'
           @click='toggleMobileMenu'>
        <div class='part'></div>
        <div class='part'></div>
        <div class='part'></div>
      </div>

      <div v-if='screenSize.mobile === true && mobileMenuActive'
           class='mobile-menu'>
        <dsMenu :language='language'>
        </dsMenu>
      </div>

    </div>

    <div v-if='screenSize.mobile === false'
         class='small-blog'>
      <div class='blog-header base-five border-bottom'>
        <div class='menu-item small-text'>
          <span class='small-text' v-if='language === "nl"'><strong>over DATAstudio</strong></span>
          <span class='small-text' v-if='language === "en"'><strong>About DATAstudio</strong></span>
        </div>
      </div>
      <div class='blog-content secondary-color border-bottom'>
        <div class='blog-content-inner' v-if='language === "nl"'>
          Er wordt nogal wat info verzameld over inwoners en de buurt waarin ze wonen, door gemeente en door bedrijven: allemaal data. Die data en datatechnologie worden ingezet om een stad slim te organiseren. Maar kun je ze ook gebruiken om als inwoners samen tot een fijnere buurt te komen?
        </div>
        <div class='blog-content-inner' v-if='language === "en"'>
          Cities and private companies collect all sorts of information on people and the neighbourhoods they live in. That’s data. Data and data technology are used to organise cities in smarter ways. But can residents also use them to make their neighbourhood a nicer place?
        </div>
        <router-link :to="{name: 'overons', params: {language: 'nl'}}">Lees meer</router-link>
      </div>
    </div>

    <div v-if='screenSize.mobile === false && language === "nl" && loaded.pages'
         v-html='overons.acf.short_text_nl'
         class='about-container padding-top roman'></div>
    <div v-if='screenSize.mobile === false && language === "en"  && loaded.pages'
         v-html='overons.acf.short_text_en'
         class='about-container padding-top roman'></div>

    <a v-if='screenSize.mobile === false'
       href='http://hetnieuweinstituut.nl/'
       class='small-hni-logo'
       target=_blank>
      <img src='../assets/hni.svg'>
    </a>

    <a v-if='screenSize.mobile === false'
       href='http://datastudio-eindhoven.nl'
       class='small-data-studio-logo'>
      <img src='../assets/logo.png'>
    </a>

    <!-- <div v-if='screenSize.mobile === false' id='newsletter'>
    <dsMailingList :language='language'>
    </dsMailingList>
  </div> -->

  </nav>
</template>

<script>
import dsCalendar from './dsCalendar'
import dsMailingList from './dsMailingList'
import dsMenu from './dsMenu'
import truncate from 'truncate'

export default {
  name: 'dsSideBar',
  components: {
    dsCalendar,
    dsMailingList,
    dsMenu
  },
  props: ['language', 'screenSize', 'posts', 'overons', 'loaded', 'location'],
  data() {
    return {
      mobileMenuActive: false
    }
  },
  methods: {
    toggleMobileMenu() {
      if (this.mobileMenuActive) {
        this.mobileMenuActive = false
      } else {
        this.mobileMenuActive = true
      }
    },
    makeHeightofMain() {
      if (!window.matchMedia('(max-width: 520px)').matches) {
        setTimeout(() => {
          document.getElementById('sidebar').style.height =
            document.getElementById('main').clientHeight + 100 + 'px'
        }, 1000)
      } else {
        document.getElementById('sidebar').style.height = '50px'
      }
    }
  },
  computed: {
    smallBlogEN() {
      return truncate(this.posts.blog.acf.excerpt_en, 310)
    },
    smallBlogNL() {
      return truncate(this.posts.blog.acf.excerpt, 310)
    }
  },
  watch: {
    $route: {
      handler: function() {
        this.mobileMenuActive = false
        this.makeHeightofMain()
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import '../styles/helpers/_mixins.scss';
@import '../styles/responsive/_manager.scss';
@import '../styles/_variables.scss';
@import '../styles/_space.scss';
@import '../styles/_color.scss';
@import '../styles/_typography.scss';

nav {
  float: left;
  position: relative;
  width: $sidebar;
  margin-right: $margin;
  box-shadow: 0 -1px 0 $main-color inset;
  @include screen-size('x-small') {
    width: $column;
    box-shadow: 0 0 0 $main-color inset;
  }
}
.small-data-studio-logo {
  display: block;
  height: 13 * $baseline;
  border: 0;
  &:hover {
    border: 0;
  }
  img {
    position: relative;
    // left: -10px;
  }
}
.small-hni-logo {
  display: block;
  height: 22 * $baseline;
  border: 0;
  &:hover {
    border: 0;
  }
}
#bottom-sidebar {
  position: absolute;
  bottom: 0;
  margin-bottom: 2 * $baseline;
}

#description {
  p {
    margin-bottom: 0;
    position: relative;
    top: 8px;
    font-family: 'UniversLTCYR-55Roman', 'helvetica', sans-serif;
  }
  margin-bottom: 4 * $baseline;
}
.sidebar-column {
  width: $sidebar;
  margin-right: $margin;
}

#title {
  display: block;
  width: 100%;
  @include screen-size('x-small') {
    position: fixed;
    top: $baseline;
    left: $margin;
    background: $background-color;
    z-index: 1000;
    width: calc(100% - (2 *#{$margin}));
    max-width: $column;
  }
  svg {
    position: absolute;
    bottom: 17px;
    width: 100%;
    @include screen-size('x-small') {
      width: auto;
    }
    path {
      fill: $main-color;
    }
    &:hover {
      path {
        fill: $high-light;
      }
    }
  }
}

.menu-item {
  height: 2 * $baseline;
  font-size: $large-text;
  white-space: nowrap;
  text-decoration: none;
  text-align: left;
  position: absolute;
  bottom: 2 * $baseline;
  @include screen-size('x-small') {
    height: auto;
    padding-top: 3 * $baseline;
    position: static;
  }
}

.blog-content {
  overflow: hidden;
  height: 44 * $baseline;
  padding-top: $baseline;
  padding-bottom: $baseline;
}

.three-bar {
  display: none;
  position: absolute;
  top: $baseline / 1.5;
  right: 0;
  width: 40px;
  cursor: pointer;
  transform-origin: 50% 50% 0;
  z-index: 100000;
  height: 5 * $baseline;
  .part {
    width: 100%;
    height: $baseline / 2;
    background: $main-color;
    transform-origin: 50%;
    margin-top: $baseline / 2;
    background: $main-color;
  }
  &:hover {
  }
  &.close {
    .part {
      background: $high-light;
    }
  }
  @include screen-size('x-small') {
    display: block;
  }
}

.top-block {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 6 * $baseline;
  background: $background-color;
  z-index: 100;
  display: none;
  @include screen-size('x-small') {
    display: block;
  }
}

.mobile-menu {
  background: $background-color;
  display: inline-block;
  width: calc(100% - (2 *#{$margin}));
  position: fixed;
  top: 6 * $baseline;
  border-bottom: 1px solid $main-color;
  display: block;
}

.menu-title {
  position: absolute;
  bottom: 1.5 * $baseline;
}

.calendar-wrapper {
  height: 22 * $baseline;
  overflow: hidden;
}
.menu-item {
  span {
    position: relative;
    top: 5px;
  }
}

.blog-content-inner {
  hyphens: auto;
}
</style>



// WEBPACK FOOTER //
// dsSideBar.vue?3faca4da